import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import { editCouncilLitigation2 } from "services/prosecutorDecipilineService";
import { CouncilLitigation } from "types";
import { LoadingIcon } from "utils/constant";
import "../styles/AddVictimModal.css";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  councilLitigationData: CouncilLitigation;
  onComplaintRefresh: any;
}

export default function RejectLitigationModal({
  isOpen,
  setIsOpen,
  councilLitigationData,
  onComplaintRefresh,
}: ModalProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    response_from_general_council: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!councilLitigationData?.id) {
      showToast("Complaint not found!", "error");
      return;
    }
    setLoading(true);

    try {
      await editCouncilLitigation2(
        {
          response_from_general_council:
            formState?.response_from_general_council,
        },
        councilLitigationData?.id
      );

      onComplaintRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      setFormState({
        response_from_general_council: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Reject Appeal Claim"}
    >
      <form onSubmit={handleSubmit} className="victim-form">
        <section className="victim-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Response
            </label>
            <textarea
              required
              rows={4}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="response_from_general_council"
              placeholder="Response here ..."
              value={formState.response_from_general_council}
              onChange={handleChange}
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Reject Appeal Claim"
          )}
        </button>
      </form>
    </SideModal>
  );
}
